import React from 'react';
import { Grid, Message, Responsive } from 'semantic-ui-react';
import SidebarTitle from 'components/Sidebar/SidebarTitle';
import { Field, Form, Formik } from 'formik';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import MainButton from 'components/Buttons/MainButton';
import moment from 'moment';
import CustomTextareaComponent from 'components/Form/CustomTextareaComponent';
import { isTabletOrLess } from 'utils/isMobile';

const EditPostIt = ({ patient, onSubmit, hideSidebar }) => (
	<div style={{ width: '100%', height: '100%', display: 'flex' }}>
		<Responsive
			minWidth={1024}
			as='div'
			style={{
				width: '50%',
				padding: '1rem',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		></Responsive>
		<div
			style={{
				width: isTabletOrLess() ? '100%' : '50%',
				backgroundColor: 'rgb(236, 240, 244)',
				padding: '2rem',
				overflowY: 'auto',
			}}
		>
			<Grid>
				<SidebarTitle title='Modifier un Post-It' />

				<Grid.Row columns={1}>
					<Grid.Column style={{ padding: 0 }}>
						<Message
							warning
							header='Attention!'
							content='Merci de ne saisir que des informations cliniques et pertinentes sur le patient.'
						/>

						<Formik
							initialValues={{
								id: patient.id,
								post_it: patient.post_it || '',
							}}
							onSubmit={(values) => {
								values.last_update_post_it = moment().format('YYYY-MM-DD');
								hideSidebar();
								onSubmit(values);
							}}
						>
							{({ isSubmitting }) => (
								<Form>
									<Field
										type='textarea'
										name='post_it'
										customlabel='Post-It'
										placeholder=''
										component={CustomTextareaComponent}
									/>
									<Grid className='gridWithNoMarginMobile'>
										<Grid.Row columns={3} style={{ marginTop: 20 }}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ width: '100%' }}
													text='Annuler'
													onClick={(e) => {
														if (e !== undefined) e.preventDefault();
														hideSidebar();
													}}
												/>
											</Grid.Column>
											<Grid.Column></Grid.Column>
											<Grid.Column>
												<MainButton
													style={{ width: '100%' }}
													text='Valider'
													type='submit'
												/>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</div>
	</div>
);

export default EditPostIt;
